import { classes } from '../types/class';
import axiosInstance from '../api/apiInterceptor';
import { AxiosResponse } from 'axios';
import {class_API_ENDPOINT,CLASS_API_ENDPOINT_WITH_FILTER} from "../../../constants/constants";
import {getUserDetails} from "../../../lib/getUserDetails";


export const fetchclassesApi = async (): Promise<classes[]> => {
  const userData=getUserDetails();
  const schoolId=userData[0].relatedEntity.schools.id;
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${CLASS_API_ENDPOINT_WITH_FILTER}|${schoolId}&limit=1000`);
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching classes:', error);
    throw error;
  }
};
 
export const addclassApi = async (classData: Omit<classes, 'id'>): Promise<classes> => {
  try {
    const response: AxiosResponse<classes> = await axiosInstance.post(class_API_ENDPOINT, classData);
    return response.data.data;
  } catch (error: any) {
    console.error('Error adding class:', error);
    throw error;
  }
};

export const updateclassApi = async (classes: classes): Promise<classes> => {
  try {
    const response: AxiosResponse<classes> = await axiosInstance.patch(`${class_API_ENDPOINT}/${classes.id}`, classes);
    return response.data;
  } catch (error: any) {
    console.error('Error updating class:', error);
    throw error;
  }
};

export const deleteclassApi = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${class_API_ENDPOINT}/${id}`);
    return id;
  } catch (error: any) {
    console.error('Error deleting class:', error);
    throw error;
  }
};